import * as St from './RemoveModal.styles';

import CommonButton from '~atoms/CommonButton';

type RemoveModalProps = {
  title: string;
  description: string;
  buttons: {
    cancel: string;
    confirm: string;
  };
  isVisible: boolean;
  handleClose: () => void;
  handleChange: () => void;
};

const RemoveModal = ({
  title,
  description,
  buttons,
  isVisible,
  handleClose,
  handleChange,
}: RemoveModalProps) => (
  <St.Container
    type="remove"
    title={title}
    content={description}
    isVisible={isVisible}
    onClose={handleClose}
    footer={[
      <CommonButton
        key="back"
        onClick={handleClose}
        data-style="remove-secondary"
      >
        {buttons.cancel}
      </CommonButton>,
      <CommonButton key="submit" onClick={handleChange}>
        {buttons.confirm}
      </CommonButton>,
    ]}
  />
);

export default RemoveModal;
